import data from "../../../../data/schema/shared/sharedData";

export default {
  name: "Employer Profile",
  sections: [
    {
      name: "Employer - Name",
      fields: [
        {
          machine_name: "new_profile_emp_legal_name",
          widget: "text",
          label: "Legal Business Name",
          validate: ["required"],
          maxLength: 120,
          tooltip:
            "Enter the full name of the individual employer, joint employer, job contractor, partnership, corporation, i.e. the employer filing this application.  The employer’s full legal business name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).",
        },
        {
          machine_name: "new_profile_emp_dba",
          widget: "text",
          label: "Trade name/Doing Business As (DBA), if applicable",
          maxLength: 120,
          tooltip:
            "Enter the full trade name or 'Doing Business As' (DBA) name, if applicable, of the business, person, association, firm, corporation, or organization, i.e., the employer filing this application.",
        },
      ],
    },
    {
      name: "Employer - Address",
      fields: [
        {
          machine_name: "new_profile_emp_address1",
          widget: "text",
          label: "Address 1",
          validate: ["required"],
          maxLength: 60,
          tooltip:
            "Enter the business street address for the employer.  The address must be a physical location and not a separate P.O. Box.  Since the addressing in the CNMI does not always follow the same entry format, see the Address Note for CNMI at the end of these general instructions.",
        },
        {
          machine_name: "new_profile_emp_address2",
          widget: "text",
          label: "Address 2",
          maxLength: 60,
          tooltip:
            "If additional space is needed for the street address, use this data field to complete the employer's street address.",
        },
        {
          machine_name: "new_profile_emp_city",
          widget: "text",
          label: "City",
          validate: ["required"],
          maxLength: 35,
          tooltip:
            "Enter the city of the employer's principal place of business.",
        },
        {
          machine_name: "new_profile_emp_country_id",
          widget: "select",
          label: "Country",
          selection: data.country,
          clearSchema: ["new_profile_emp_state_id"],
          validate: ["required"],
          tooltip:
            "Enter the country of the employer’s principal place of business.",
        },
        {
          machine_name: "new_profile_emp_state_id",
          widget: "select",
          label: "State",
          selection: data.state,
          validate: ["required"],
          tooltip:
            "Enter the State, District, or Territory of the employer’s principal place of business.",
          isVisible: {
            when: "new_profile_emp_country_id",
            is: "UNITED STATES OF AMERICA",
          },
        },
        {
          machine_name: "new_profile_emp_zip",
          widget: "text",
          label: "Postal code",
          validate: [
            "required",
            {
              postalCountry: "new_profile_emp_country_id",
              needsFieldValues: true,
              extraData: {
                valueOf: "new_profile_emp_country_id",
              },
            },
          ],
          maxLength: 10,
          tooltip:
            "Enter the postal (zip) code of the employer’s principal place of business.",
        },
        {
          machine_name: "new_profile_emp_province",
          widget: "text",
          label: "Province",
          maxLength: 25,
          tooltip:
            "Enter the province of the employer’s principal place of business, if applicable.",
        },
      ],
    },
    {
      name: "Employer - Contact Information",
      fields: [
        {
          machine_name: "new_profile_emp_phone",
          widget: "phone",
          label: "Telephone Number",
          validate: ["required", "phone"],
          tooltip:
            "Enter the area code and telephone number for the employer’s principal place of business.",
        },
        {
          machine_name: "new_profile_emp_phone_ext",
          widget: "phone_ext",
          label: "Extension",
          validate: ["number"],
          maxLength: 4,
          tooltip:
            "Enter the extension of the telephone number for the employer’s principal place of business, if applicable.",
        },
      ],
    },
    {
      name: "Employer - Identifiers",
      fields: [
        {
          machine_name: "new_profile_emp_fein",
          widget: "text",
          label: "Federal Employer Identification Number (FEIN from IRS)",
          validate: ["required", "fein", { minLength: 10 }],
          parse: "fein",
          maxLength: 10,
          tooltip:
            "Enter the nine-digit Federal Employer identification Number (FEIN) as assigned by the IRS.  Do not enter a social security number. Important Note: All employers, including private households, MUST obtain an FEIN from the IRS before completing this application.  Information on obtaining an FEIN can be found at www.irs.gov.",
        },
        {
          machine_name: "new_profile_emp_naics_description",
          widget: "text",
          label: "NAICS Description",
          validate: ["required"],
          hidden: true,
        },
        {
          machine_name: "new_profile_emp_naics",
          widget: "naics",
          label: "NAICS Code",
          validate: ["required"],
          field_to_modify: "new_profile_emp_naics_description",
          tooltip:
            'Enter the four-to-six digit North American Industry Classification System (NAICS) code that best describes the employer’s business, not the foreign national’s job classification. A listing of NAICS codes can be found at <a href="http://www.census.gov/eos/www/naics">http://www.census.gov/eos/www/naics</a>',
        },
      ],
    },
    {
      name: "Employer - Business Information - PERM Only",
      fields: [
        {
          machine_name: "new_profile_emp_year_commenced",
          widget: "text",
          parse: "positiveNumber",
          validate: ["number", "noInvalidYear"],
          maxLength: 4,
          label: "Year Commenced Business (if household, year issued FEIN)",
          tooltip:
            "Enter the year the employer began business or was incorporated. If the employer is a private household, enter the year the IRS issued a FEIN. Use a full year (YYYY) format.",
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_emp_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          validate: ["required"],
          maxLength: 60,
          tooltip:
            "Enter a unique name that will allow you to identify this profile",
        },
      ],
    },
  ],
};
